import React from 'react';
import { ISVGType } from './SVGType';

const DropdownArrowIcon = (props: ISVGType) => {
  const { width = 8, height = 5, color = "#0A0C30" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 5"
      fill="none"
    >
      <path
        d="M6.97324 0.185628C7.0864 0.0667093 7.23919 0 7.39843 0C7.55766 0 7.71046 0.0667093 7.82361 0.185628C7.87948 0.244024 7.92384 0.31363 7.95412 0.390396C7.98441 0.467162 8 0.549554 8 0.632777C8 0.716 7.98441 0.798392 7.95412 0.875158C7.92384 0.951924 7.87948 1.02153 7.82361 1.07993L4.42562 4.61467C4.31221 4.73342 4.15931 4.8 4 4.8C3.84069 4.8 3.68779 4.73342 3.57438 4.61467L0.176388 1.07993C0.120524 1.02153 0.076159 0.951924 0.0458768 0.875158C0.0155947 0.798392 0 0.716 0 0.632777C0 0.549554 0.0155947 0.467162 0.0458768 0.390396C0.076159 0.31363 0.120524 0.244024 0.176388 0.185628C0.28954 0.0667093 0.442339 0 0.601573 0C0.760806 0 0.913605 0.0667093 1.02676 0.185628L4.0013 3.08448L6.97324 0.185628Z"
        fill={color}
      />
    </svg>
  )
};

export default DropdownArrowIcon;
